import {createApp} from 'vue'
import App from './views/App.vue';
import Login from './views/Login.vue';
import StrongPass from './views/StrongPass.vue';
import store from './store';
import router from './router';
import api from './api';
import heyui, {confirm, loading, message} from "heyui.ext";
import AppContent from './components/AppContent';
import AccountDateChoose from './components/AccountDateChoose';
import SubMenu from './components/common/sub-menu';
import RouterLink from './components/RouterLink';
import RouterDbLink from './components/RouterDbLink';
import Chart from './views/app/chart/echarts';
import {useTable} from '@js/common/xe-table';
import filters from './js/common/filters';
import '@layui/layer-vue/lib/index.css';
import layer from '@layui/layer-vue';

import './js/config/dict';
import 'windi.css'
import 'font-awesome/css/font-awesome.css'
import './styles/app.less';

let app;
store.dispatch("init").then((data) => {
	if(data.user["isStrongPass"]===false){
		app = createApp(StrongPass).use(store).use(heyui).use(filters);
		app.config.globalProperties.$api = api;
		app.config.globalProperties.$Message = message;
	}else{
		app = createApp(App);
		app.config.globalProperties.$api = api;
		app.config.globalProperties.$Message = message;
		app.config.globalProperties.$Loading = loading;

		app.config.globalProperties.$Confirm = (content) => {
			return new Promise((resolve, reject) => {
				confirm({
					title: "操作提示",
					content,
					onConfirm: resolve,
					onCancel: reject
				})
			})
		};

		app.use(useTable).use(layer).use(filters).use(router).use(heyui).use(store);
		app.component("app-content", AppContent);
		app.component("account-date-choose", AccountDateChoose);
		app.component('sub-menu', SubMenu);
		app.component('Chart', Chart);
		app.component('RouterLink', RouterLink);
		app.component('RouterDbLink', RouterDbLink);
	}


}).catch((err) => {
	app = createApp(Login).use(store).use(heyui).use(filters);
	app.config.globalProperties.$api = api;
	app.config.globalProperties.$Message = message;
}).finally(() => {
	app.config.globalProperties.APP_NAME = process.env.VUE_APP_NAME;
	app.config.globalProperties.BUID_DATE = process.env.VUE_APP_BUID_DATE;
	app.config.globalProperties.VERSION ="1.0.0.1";//process.env.VUE_APP_VERSION;
	app.mount('#app')
});
